<fieldset class="border mt-2 mb-3 ps-2">
  <legend class="w-auto m-0 p-0">Consult Note {{ position + 1 }}</legend>
  <div class="pb-2 ps-1 form-inline">
    <label><strong>Encounter Date</strong></label>
    <div class="input-group encounter-date ms-2">
      <input
        name="encounterDate"
        type="date"
        class="form-control encounter-date-input"
        autocomplete="off"
        placeholder="MM/DD/YYYY"
        [disabled]="disabled"
        [(ngModel)]="encounterDate"
        (blur)="onEncounterDateBlur()"
        />
      @if (encounterDate && !disabled) {
        <button
          (click)="onDateClearClick()"
          class="btn clear-button"
          type="button">
          <span>×</span>
        </button>
      }
    </div>
    @if (!disabled) {
      <div class="actions ms-2">
        @if (position > 0) {
          <a
            href="#/remove"
            class="text-danger ms-1 text-small"
            (click)="onRemoveClick($event, verification)">
            Remove
          </a>
        }
      </div>
    }
  </div>
</fieldset>
